import trackConfigurationData from './trackConfiguration.json';

export default trackConfigurationData; 